import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapTableInitiativeWorkstreamsRoute extends Route {
  @service store;
  @service users;

  async setupController(controller, model) {
    super.setupController(controller, model);
    this.users.getUsers();
    model.weeks.then((results) => controller.set('_weeks', results));
    model.tfos.then((results) => controller.set('otherItems', results));
    model.workstreams.then((results) => controller.set('workstreams', results));
  }

  model() {
    return this.modelFor('backlog.initiatives.initiative');
  }
}

export default instrumentRoutePerformance(
  RoadmapTableInitiativeWorkstreamsRoute,
);
